import { apiSpaceUrl } from "utils/urls";

import axios from "axios";

export const getPaperSearch = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("paperSearch", spaceUuid), { params: params });
    return data;
};

export const getConvertedPaper = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("paperSearch", spaceUuid), body);
    return data;
};

export const getPaperSearchHistory = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("paperSearchHistory", spaceUuid), {
        params: params,
    });
    return data;
};

export const deletePaperSearchHistory = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("paperSearchHistory", spaceUuid), {
        data: body,
    });
    return data;
};

export const getPaperRecommendation = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("paperRecommendation", spaceUuid), {
        params: params,
    });
    return data;
};

export const getPaperMetadata = (spaceUuid, params) => {
    return axios.get(apiSpaceUrl("paperMetadata", spaceUuid), { params: params });
};

export const getTags = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("tag", spaceUuid), { params: params });

    data.sort((a, b) => {
        if (a.name < b.name) return -1;
        else return 1;
    });
    return data;
};

export const postTag = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("tag", spaceUuid), body);
    return data;
};

export const putTag = async (spaceUuid, body) => {
    const { data } = await axios.put(apiSpaceUrl("tag", spaceUuid) + `/${body.id}`, body);
    return data;
};
export const deleteTag = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("tag", spaceUuid) + `/${body.id}`);
    return data;
};

export const deleteBulkTag = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("tag", spaceUuid) + `/bulk-delete`, { data: body });
    return data;
};

export const addTagReference = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("tag", spaceUuid) + `/reference`, body);
    return data;
};

export const changeTagOrder = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("tag", spaceUuid) + `/order`, body);
    return data;
};

export const getTagRecommendation = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("tag", spaceUuid) + `/recommend`, body);
    return data;
};

export const getFolders = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("folder", spaceUuid), { params: params });
    return data;
};

export const postFolder = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("folder", spaceUuid), body);
    return data;
};

export const putFolder = async (spaceUuid, body) => {
    const { data } = await axios.put(apiSpaceUrl("folder", spaceUuid) + `/${body.id}`, body);
    return data;
};
export const deleteBulkFolder = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("folder", spaceUuid) + `/bulk-delete`, { data: body });
    return data;
};

export const addFolderReference = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("folder", spaceUuid) + `/reference`, body);
    return data;
};

export const changeFolderOrder = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("folder", spaceUuid) + `/order`, body);
    return data;
};

export const mergeFolder = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("folder", spaceUuid) + `/merge`, body);
    return data;
};
